module.exports = __webpack_public_path__ + "img/iconmonstr-twitter-1-dark.af9ab6fa.svg";